import { takeUntil } from 'rxjs/operators';
import { debounceTime } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { GridApi, GridOptions, Module } from "@ag-grid-community/core";
import { ServerSideRowModelModule } from "@ag-grid-enterprise/server-side-row-model";
import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { LoadingCellRendererComponent } from "src/app/ag-grid-components/loading-cell-renderer/loading-cell-renderer.component";
import { SkuDetail } from "src/app/models/priceyard.model";
import { HumanizeDatePipe } from "src/app/pipes/humanize-date.pipe";
import { InventoryService } from "src/app/services/inventory.service";
import { PriceyardService } from 'src/app/modules/priceyard/services/priceyard.service';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { SyncDisablePopupComponent } from '../sync-disable-popup/sync-disable-popup.component';
import { SnackbarComponent } from 'src/app/components/snackbar/snackbar.component';
import { PlanyardService } from 'src/app/modules/planyard/planyard.service';


const humanizeDatePipe = new HumanizeDatePipe("en-US");
@Component({
  selector: "app-sync-history",
  templateUrl: "./sync-history.component.html",
  styleUrls: ["./sync-history.component.scss", "../mini-grid.scss"],
})
export class SyncHistoryComponent implements OnInit, OnDestroy {
  _sku: SkuDetail;
  get sku(): SkuDetail {
      return this._sku;
  }
  @Input('sku') set sku(value: SkuDetail) {
      this._sku = value;
      this.getInfo();
  }
  gridApi: GridApi;
  modules: Module[] = [ServerSideRowModelModule];
  syncInventory: FormControl = new FormControl();
  maxSyncQty: FormControl = new FormControl();
  destroy$ = new Subject();

  isSyncEnabled:boolean=false;
  removeStock:boolean = false;
  syncHistory: any[] = [
    {
      "id": "1",
      "syncDate": new Date(),
      "oldQty": "Success",
      "newDate": "Full",
    }
  ];
  columnDefs = [
    {
      headerName: "Sync Date",
      field: "SyncDate",
      filter: "agDateColumnFilter",
      valueFormatter: (params) => humanizeDatePipe.transform(params.value, 'MM/dd/yyyy h:mm a'),
      sortable: true
    },
    {
      headerName: "Old Qty",
      field: "OldQty",
      filter: "agNumberColumnFilter",
      sortable: true
    },
    {
      headerName: "New Qty",
      filter: 'agNumberColumnFilter',
      field: "NewQty",
      sortable: true
    },
  ];
  frameworkComponents = {
    loadingCellRenderer: LoadingCellRendererComponent,
  };
  gridOptions: GridOptions = {
    rowModelType: "serverSide",
    suppressServerSideInfiniteScroll: false,
    defaultColDef: {
      resizable: true,
      sortable:false
    },
    columnDefs: this.columnDefs,
    components: this.frameworkComponents,
    loadingCellRenderer: "loadingCellRenderer",
    icons: {
      menu: '<span class="ag-icon ag-icon-filter" unselectable="on" role="presentation"></span>',
      filter:
        '<span class="ag-icon ag-icon-filter" style="display:none;" unselectable="on" role="presentation"></span>',
    },
    onGridReady: (e) => {
      this.gridApi = e.api;
      this.gridApi.sizeColumnsToFit();
    },
    serverSideDatasource: {
      getRows: (params: any) => {
        params.request.filterModel = {
          AccountSkuId: {
            filterType: "number",
            type: "equals",
            filter: this.sku.accountSkuId,
          }
        }
        this.inventoryService
          .SyncHistory(params.request).pipe(takeUntil(this.destroy$))
          .subscribe({
          next: (response: any) => {
              if (response) {
                if (!response.totalCount) {
                  this.gridApi.showNoRowsOverlay();
                } else {
                  this.gridApi.hideOverlay();
                }
                params.success({
                  rowData: response.data,
                  rowCount: response.totalCount,
                });
              }
            },
         error: (err) => {
          params.fail()
         }
       });
      },
    }
  };

  constructor(
    private inventoryService: InventoryService,
    private priceyardServcie: PriceyardService,
    private planyardService:PlanyardService,
    private snackbar:MatSnackBar,
    private dialog:MatDialog

  ) { }

  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.unsubscribe();
  }
  
  ngOnInit() {
    this.syncInventory.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(e => {
      const payload = {
        accountSkuId: this.sku.accountSkuId,
        syncEnabled:e,
        zeroOut:this.removeStock
      };
      this.planyardService.SyncEnabled(payload).pipe(takeUntil(this.destroy$)).subscribe((res:any)=>{
        this.snackbar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Sync settings has been saved successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
        );       
      })
    });

    this.maxSyncQty.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(1000)
      )
      .subscribe(e => {
      const payload = [{
        sku: this.sku.sku,
        account: this.sku.account,
        accountSkuId: this.sku.accountSkuId,
        otherChanges: [{
          name: "MaxSyncQty",
          intValue: e,
        }]
      }];
      
      this.priceyardServcie.changePriceFactor(payload).pipe(takeUntil(this.destroy$)).subscribe((res)=>{
        this.snackbar.openFromComponent(SnackbarComponent,
          {
            duration: 3000,
            horizontalPosition: 'center',
            data: {
              title: 'Sync max qty has been changed successfully',
              action: 'Dismiss',
              type: 'success',
            },
          }
        );
      })
    });
    
  }

  resized(e) {
    this.gridApi.sizeColumnsToFit();
  }

  getInfo() {

    this.isSyncEnabled = this.sku.skuStockEnabled;

    this.syncInventory.setValue(this.sku.skuStockEnabled, {emitEvent: false});
    this.maxSyncQty.setValue(this.sku.maxSyncQty, { emitEvent: false });
    // refresh grid
    this.gridApi?.refreshServerSide({purge: true});
  }


  removeInventory(){
    this.maxSyncQty.setValue(null);
  }

  change(event){
    if(!event.checked && this.sku.channelSync){     
      const dialog = this.dialog.open(SyncDisablePopupComponent, {
        width: "476px",
        data: {
          title: "Are you sure you want to disable sync?"
        },
      });
      dialog
        .afterClosed()
        .subscribe((e) => {
          if(e){
            this.removeStock = e.removeStock || false;
            this.syncInventory.setValue(event.checked);           
          }          
          else{
            this.isSyncEnabled=true;
          }
        }
    );
    } else{
      this.removeStock = false;
      this.syncInventory.setValue(event.checked);
    }
  }

  syncSkuStock(){
    const payload={
      accountSkuId:this.sku.accountSkuId,
      qty:0
    }
    this.inventoryService.syncSkuStock(payload).pipe(takeUntil(this.destroy$)).subscribe({
     next: (res) => {
      this.snackbar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: 'Sync sku stock has been changed successfully',
            action: 'Dismiss',
            type: 'success',
          },
        }
      );
    },
     error: (err) => {
      this.snackbar.openFromComponent(SnackbarComponent,
        {
          duration: 3000,
          horizontalPosition: 'center',
          data: {
            title: err.error.error[0],
            action: 'Dismiss',
            type: 'error',
          },
        }
      );
     }
    })
  }

}
